import * as React from "react";
import { DataGrid } from "devextreme-react";
import { Column } from "devextreme-react/data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClock, faFileDownload, faTimes, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { ServiceContext } from "src/services/provider/Service.provider";
import { useContext } from "react";
import { MoneyMask } from "src/util/Masks/MoneyMask";
import "./TedModal.scss";
import { Modal } from "antd";
import { ShowNotification } from "../../ShowNotification/ShowNotification";
import { formatDate } from 'src/util/Date.helper';
import { GenericIcon } from '../../Icons/GenericIcon/GenericIcon';
import { ITrade } from 'src/services/interfaces/trade/ITrade';
import { DisbursementTriggerLabel } from 'src/services/Enum/DisbursementTriggerEnum';
import { IDisbursementPricing } from 'src/services/interfaces/calculator/IDisbursementPricing';
import { DisbursementTriggerActivationTypeLabel } from 'src/services/Enum/DisbursementTriggerActivationTypeEnum';
import * as _ from 'lodash';

interface ITedsModal {
  trade: ITrade;
  visible: boolean;
  onClose: () => void;
}

export const TedsModal: React.FC<ITedsModal> = ({ trade, visible, onClose }) => {
  const { documentService } = useContext(ServiceContext);

  const moneyMask = ({ value }) => MoneyMask(value!);

  const handleDownload = (fileKey: string) => {
    documentService.ted(trade, fileKey).catch(() => ShowNotification.Error("Erro ao baixar arquivo", "Ocorreu um erro ao baixar a TED, tente novamente."));
  };

  const genericIcon = (label: string, className: string, icon: IconDefinition) => <GenericIcon showLabel={false} iconConfig={{ icon, label, className }} />;
  const hasConditional = trade.tradePricing.pricing.pricingDisbursements.some(p => p.hasTriggerConditional);

  return (
    <Modal title="Visualização de desembolsos" className="modal-view-teds modal-large" okText="Fechar" cancelButtonProps={{ hidden: true }} visible={visible} onOk={onClose}>
      <DataGrid dataSource={trade.tradePricing.pricing.pricingDisbursements} showBorders columnAutoWidth>
        <Column
          caption="Preço Ativo"
          alignment="center"
          dataField="active"
          dataType="boolean"
          cellRender={({ value }) => (value ? genericIcon("Ativo", "success", faCheck) : null)}
        />
        <Column
          caption="TED enviado"
          alignment="center"
          dataField="tedDocumentKey"
          dataType="boolean"
          cellRender={(params) => {
            const data: IDisbursementPricing = params.data;
            if (data.tedDocumentKey) {
              return (genericIcon("Pago", "success", faCheck))
            } else {
              if (data.triggerGroupAlreadyDisburse && !data.alreadyPaid) {
                return genericIcon("Outra P2 condicional já foi desembolsada", "danger", faTimes);
              } if (trade.tradePricing.pricing.pricingDisbursements.some(t => t.id !== data.id && t.trigger === data.trigger && t.active) && !data.alreadyPaid && !data.active) {
                return genericIcon("P2 não possui os requisitos necessários", "danger", faTimes);
              } else {
                return genericIcon("Não enviado, aguardando envio da TED", "warning", faClock);
              }
            }
          }}
        />
        <Column caption="Data prevista" alignment="center" dataField="expectedDate" dataType="date" format="dd/MM/yyyy" />
        <Column
          caption="Data realizada"
          alignment="center"
          dataField="disbursementDate"
          dataType="date"
          format="dd/MM/yyyy"
          cellRender={params => (params.data.disbursementDate ? formatDate(params.data.disbursementDate) : "-")}
        />
        <Column caption="Preço" alignment="center" dataField="price" dataType="number" cellRender={moneyMask} />
        <Column
          caption="Momento do pagamento"
          alignment="center"
          dataField="trigger"
          dataType="string"
          cellRender={({ data: { trigger } }) => (DisbursementTriggerLabel.get(trigger))}
        />
        <Column
          caption="TED"
          alignment="center"
          width="100px"
          dataField="tedDocumentKey"
          dataType="file"
          cellRender={({ value }) => (
            <button className="btn icon-only" disabled={_.isEmpty(value)} onClick={() => handleDownload(value)}>
              <FontAwesomeIcon icon={faFileDownload} />
            </button>
          )}
        />
        <Column visible={hasConditional} caption="Ativação" alignment="center" dataField="activationType" dataType="string" cellRender={(params) => (DisbursementTriggerActivationTypeLabel.get(params.data.activationType))} />
        <Column
          visible={hasConditional}
          caption="Data trigger condicional inicial"
          alignment="center"
          dataField="triggerConditionalInitialDate"
          dataType="date"
          format="dd/MM/yyyy"
          cellRender={(params) => (
            params.data.triggerConditionalInitialDate ? formatDate(params.data.triggerConditionalInitialDate) : "-"
          )} />
        <Column
          caption="Data trigger condicional final"
          alignment="center"
          dataField="triggerConditionalFinalDate"
          dataType="date"
          format="dd/MM/yyyy"
          visible={hasConditional}
          cellRender={(params) => (
            params.data.triggerConditionalFinalDate ? formatDate(params.data.triggerConditionalFinalDate) : "-"
          )} />
        <Column
          visible={hasConditional}
          caption="Descrição do trigger"
          alignment="center"
          dataField="triggerDescription" />
        <Column dataField="trigger" dataType="string" groupIndex={0} />

      </DataGrid>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/GenericButtons/ViewTedButton/TedsModal.tsx